import React, { Component } from 'react';
import { trackInfo, infoMessage } from 'helpers';

export class ErrorBoundary extends Component {
  state = {
    errorMessage: '',
  };
  static getDerivedStateFromError(error: any) {
    return { errorMessage: error.toString() };
  }
  componentDidCatch(error: any, info: any) {
    trackInfo(infoMessage.ErrorBoundary, {
      error: error.toString(),
      componentStack: JSON.stringify(info.componentStack),
    });
  }

  render() {
    if (this.state.errorMessage) {
      return <p>{this.state.errorMessage}</p>;
    }
    return this.props.children;
  }
}
